<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row>
        <v-col cols="12">
          <h1 class="primary--text font-weight-medium">
            {{ $t('transfer_request_recurrence') }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-radio-group
            v-model="clientRequest.schedule.recurrent"
            @change="handleRadio"
          >
            <v-radio
              :value="false"
            >
              <template #label>
                <span class="label primary--text">{{ $t('transfer_request_non_recurring') }}</span>
              </template>
            </v-radio>
            <v-radio
              class="mt-5"
              :value="true"
            >
              <template #label>
                <span class="label primary--text">{{ $t('transfer_request_recurrent') }}</span>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row v-if="clientRequest.schedule.recurrent">
        <v-col cols="12" md="4">
          <ValidationProvider
            :name="$t('transfer_request_monthly_frequency')"
            rules="required|min_value:1|max_value:12|max:50|numeric"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="`${$t('transfer_request_monthly_frequency')} *`"
              dense
              autocomplete="nope"
              v-model="clientRequest.schedule.monthlyFrequency"
              :error-messages="errors[0]"
              maxlength="50"
              v-mask="'##'"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="4">
          <ValidationProvider
            :name="$t('transfer_request_business_day')"
            rules="required|max:50|min_value:1|max_value:31"
            v-slot="{ errors }"
          >
            <v-text-field
              :label="`${$t('transfer_request_business_day')} *`"
              dense
              autocomplete="nope"
              v-model="clientRequest.schedule.day"
              :error-messages="errors[0]"
              maxlength="50"
              v-mask="'##'"
            />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="4">
          <ValidationProvider
            :name="$t('transfer_request_end_day')"
            rules="required|max:50"
            v-slot="{ errors }"
          >
            <date-picker-input
              :label="`${$t('transfer_request_end_day')} *`"
              v-model="clientRequest.schedule.end"
              dense
              :min="minDate"
              :error-messages="errors[0]"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
import DatePickerInput from '@/components/commons/DatePickerInput'
export default {
  components: {
    WizardForm,
    DatePickerInput
  },
  props: {
    clientRequest: {
      type: [Object]
    }
  },
  computed: {
    minDate() {
      return this.$date()
        .add(1, 'day')
        .format('YYYY-MM-DD')
    }
  },
  methods: {
    handleRadio(event) {
      if (!event) {
        this.$emit('clearSchedule')
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.label
  font-size: 1.286rem
</style>
